import { render, staticRenderFns } from "./section-item-editor.vue?vue&type=template&id=53652ab0"
import script from "./section-item-editor.vue?vue&type=script&lang=ts"
export * from "./section-item-editor.vue?vue&type=script&lang=ts"
import style0 from "./section-item-editor.vue?vue&type=style&index=0&id=53652ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports